
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { setCookie, getCookie } from 'helpers/cookie-helper'
import { getDomain } from 'helpers/url-helpers'

@Defaults({
  el: '.smart-app-banner',
  events: {
    'click .js-close': 'setCookie',
    'click .js-install': 'setCookie',
  },
  // Дефолтное кол-во дней для повтора показа баннера при закрытии.
  daysClose: 15,
  // Дефолтное кол-во дней для повтора показа баннера при установке.
  daysInstall: 90,
  cookieName: 'app-popup',
})

export class MobileSmartBannerView extends View {
  /**
   * Установка куки. Если просто закрыли - 15 дней, если скачали приложение - 90 дней.
   * @param {event} e
   */
  setCookie (e) {
    let state = $(e.currentTarget).data('state'),
      breakDate
    this.$el.addClass('not_display')
    breakDate = state === 'close' ? this.daysClose * 24 * 3600 : this.daysInstall * 24 * 3600
    setCookie(this.cookieName, 1, {
      domain: '.' + getDomain(),
      path: '/',
      expires: breakDate,
    })
  }

  /**
   * Признак, что установлена кука.
   * @returns {boolean}
   */
  isCookeiActive () {
    return !getCookie(this.cookieName)
  }
}
